import * as React from 'react';
import { TitlebarKey, AiAssistantEntrance } from '@tencent/docs-titlebar-service';
import { Controller, Titlebar } from '@tencent/workbench';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWOperationType, TDWModuleType, TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { aiMenuFeature } from './ai-menu-feature';

@Controller()
export class AiMenuController {
    public constructor(private readonly aiMenuFeature: aiMenuFeature) {}

    @Titlebar(TitlebarKey.AI_ASSISTANT, 'shouldHide')
    public hideAI(): boolean {
        return this.aiMenuFeature.shouldHideAIAssistant();
    }

    @Titlebar(TitlebarKey.AI_ASSISTANT, 'content')
    public aiContent() {
        return <AiAssistantEntrance getDropdownList={() => this.aiMenuFeature.getMenuConfig()} />;
    }

    @Titlebar(TitlebarKey.AI_ASSISTANT, 'onClick')
    public aiClick() {
        tdw({
            opername: TDWOperationType.DOC_PPT_AI,
            module: TDWModuleType.TITLE_BAR_ENTRANCE,
            action: TDWActionType.CLICK,
        });
    }
}
